import CommonImg from "@/components/Common/Img";

import RadioTrue from "@/assets/images/radio-dark-brown-true.png";
import RadioFalse from "@/assets/images/radio-dark-brown-false.png";

export type RadioItem = {
  label: string;
  value: string;
};

type Props = {
  label: string;
  name: string;
  defaultValue: string;
  checked: boolean;
  onChange: (value: string) => void;
};
export default function CommonRadio({
  label,
  name,
  defaultValue,
  checked,
  onChange,
}: Props) {
  return (
    <label className="flex items-center gap-[4px] text-[10px] text-gray-B font-semibold min-w-max cursor-pointer">
      <input
        type="radio"
        className="hidden"
        name={name}
        defaultValue={defaultValue}
        checked={checked}
        onChange={() => {
          onChange?.(defaultValue);
        }}
      />
      {checked ? (
        <CommonImg className="size-3" src={RadioTrue} alt="Radio checked" />
      ) : (
        <CommonImg className="size-3" src={RadioFalse} alt="Radio unchecked" />
      )}

      {label}
    </label>
  );
}
